import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputPasswordComponent } from './input-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { DirectiveModule } from '@/directives/directive.modules';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ErrorsLabelModule } from '../errors-label/errors-label.module';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [InputPasswordComponent],
  imports: [
    CommonModule,
    ErrorsLabelModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectiveModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [InputPasswordComponent],
  providers: [provideNgxMask()],
})
export class InputPasswordModule {}
